import { createStyles, makeStyles } from '@material-ui/core'

export default makeStyles((theme) =>
  createStyles({
    bannerContainer: {
      backgroundColor: theme.palette.primary.main,
      textAlign: 'center',
      color: 'white',
      padding: theme.spacing(1),
      marginBottom: 0,
    },
    heading: {
      fontWeight: theme.typography.fontWeightBold,
      fontSize: 14,
      margin: '0 auto',
      [theme.breakpoints.down('sm')]: {
        maxWidth: 350,
      },
    },
  })
)
